module.exports = __webpack_public_path__ + "img/dod_23_03.38377f41.jpg";